// extracted by mini-css-extract-plugin
export default {"shadow":"wifiSetup_shadow__d-8f5","border":"wifiSetup_border__MG-sP","wrapper":"wifiSetup_wrapper__RnOD6"};